module.exports = __webpack_public_path__ + "static/media/status.0f3c88db.svg";